<template>
  <div class="map">
    <map-container/>
    <filters-container/>
    <settings-container/>
    <add-place-button-container/>
  </div>
</template>

<script>
import MapContainer from '@/containers/Map'
import FiltersContainer from '@/containers/Filters'
import SettingsContainer from '@/containers/Settings'
import AddPlaceButtonContainer from '@/containers/AddPlaceButton'

export default {
  components: {
    MapContainer,
    FiltersContainer,
    SettingsContainer,
    AddPlaceButtonContainer
  }
}
</script>

<style lang="scss" scoped>
  .map {
    position: relative;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/Map.vue